// const format = "This is {{1}} and the name of company is {{2}}."
// const sample = "This is [Ajay] and the name of company is [Triny]."

function ifFloating(format) {
  const validBracePattern = /\{\{[0-9]+\}\}/g; // only numbers wrapped by {{}} e.g {{1}}
  const validFloatingPattern = /^(?!\s*$)/g; // string with atleast one non-space character
  let ifFloating = false;
  // Check if each line as non-floating paramters
  format.split("\n").forEach((line) => {
    // Check if line has any content to run checks
    if (!!line.trim()) {
      const replacedText = line.replace(validBracePattern, (match) => "");
      const valid = validFloatingPattern.test(replacedText);
      if (!valid) {
        ifFloating = true;
      }
      // console.log({
      //   replacedText,
      //   valid,
      // });
    }
  });
  // console.log({ ifFloating });
  return ifFloating;
}

//Check numbers of params allowed with respect to the message length
function allowedRelativeParamLimit(format) {
  const paramCount = extractParameters(format).length;
  const formattedText = format.replace(/\s+/g, " ");
  const words = formattedText.split(" ").length - paramCount;
  const minWords = 2 * paramCount + 1;
  if (words >= minWords) return true;
  return false;
}

function validateFormat(format) {
  const validBracePattern = /\{\{[0-9]+\}\}/g;
  const invalidBracePattern = /(\{|\})/g;
  const invalidBracketPattern = /(\[|\])/g;
  // no more than 1,024 characters
  if (format.length > 1024) {
    return {
      valid: false,
      msg: "Template format length over 1024 characters.",
    };
  }
  // check consecutive empty lines
  if (
    format
      .split("\n")
      .map((i) => i.trim())
      .join("\n")
      .includes("\n\n\n")
  ) {
    return {
      valid: false,
      msg: "Consecutive empty lines not allowed in template format",
    };
  }
  // check for floating parameters
  // if (ifFloating(format)) {
  //   return {
  //     valid: false,
  //     msg: "Floating paramters aren't allowed in template format",
  //   };
  // }
  // check if the numbers of parameters are within the specified limit with respect to message length or words
  if (!allowedRelativeParamLimit(format)) {
    return {
      valid: false,
      msg: "This template contains too many variable parameters relative to the message length. You need to decrease the number of parameters or increase your message word count.",
    };
  }
  // replace valid {{}} with param value only
  const replacedText = format.replace(validBracePattern, (match) =>
    match.substring(2, match.length - 2)
  );
  // if { or } exists anywhere return false else true
  const ifCurlyValid = !invalidBracePattern.test(replacedText);
  if (!ifCurlyValid) {
    return { valid: false, msg: "Extra curly braces found in template format" };
  }
  // if [ or ] exists anywhere 	return false
  const ifBracketValid = !invalidBracketPattern.test(replacedText);
  if (!ifBracketValid) {
    return {
      valid: false,
      msg: "'[' or ']' aren't allowed in template format.",
    };
  }

  return { valid: true, msg: "Format seems legit." };
}

function extractParameters(format) {
  const validBracePattern = /\{\{[0-9]+\}\}/g;
  const parameters = [];

  function getParameter(match) {
    parameters.push(match.substring(2, match.length - 2));
  }

  const replacedText = format.replace(validBracePattern, getParameter);
  // console.log({parameters});
  return parameters;
}

function compareFormatAndSample(format, sample, strictOrdering) {
  let ifSame = false;
  const validBracePattern = /\{\{[0-9]+\}\}/g;
  const validBracketPattern = /\[([^\]]+)\]/g;
  const braceFreeText = format.replace(validBracePattern, (match) => "");
  const bracketFreeText = sample.replace(validBracketPattern, (match) => "");

  if (
    strictOrdering &&
    (format.match(/\{\{[0-9]+\}\}/g) || []).some(
      (i, index) => i !== `{{${index + 1}}}`
    )
  ) {
    return {
      valid: false,
      msg: "Invalid parameter ordering",
    };
  }

  // console.log(
  //   format,
  //   bracketFreeText,
  //   braceFreeText,
  //   braceFreeText == bracketFreeText
  // );

  if (braceFreeText === bracketFreeText) {
    return { valid: true, msg: "Format seems legit." };
  } else {
    return {
      valid: false,
      msg: "Sample message doesn't match with template format",
    };
  }
}

function validateUrl(value) {
  return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
    value
  );
}


function validateAuthenticationTemplate(
  templateType,
  authCodeExpiration,
  _viewSecurityMessage,
  buttons = []
) {
  if (templateType !== "TEXT") {
    return {
      valid: false,
      msg: "Authentication templates can only have TEXT as their template type!",
    };
  }

  const copyCodeCount = buttons.filter(({ type }) => type === "COPY_CODE").length;
  if (copyCodeCount !== 1 || buttons.length !== 1) {
    return {
      valid: false,
      msg: "Exactly one Copy Code button is mandatory for authentication templates, with no other buttons!",
    };
  }

  const copyCodeBtn = buttons.find(({ type }) => type === "COPY_CODE");
  if (!copyCodeBtn?.example || !copyCodeBtn.example.trim()) {
    return {
      valid: false,
      msg: "Sample code value is required for the Copy Code button.",
    };
  }

  if (authCodeExpiration) {
    if (
      isNaN(authCodeExpiration) ||
      authCodeExpiration < 1 ||
      authCodeExpiration > 90
    ) {
      return {
        valid: false,
        msg: "Expiration warning should be between 1 to 90 minutes!",
      };
    }
  }

  return { valid: true, msg: "No errors found!" };
}

function validateButtons(buttons, category) {
  if (!buttons?.length) return { valid: true, msg: "Buttons not selected!" };

  const buttonTextPattern = /^(?!\s*$).{0,25}$/;
  const buttonsLen = buttons.length || 0;

  if (buttonsLen > 10) {
    return { valid: false, msg: "Maximum 10 buttons allowed!" };
  }

  const buttonsMetaData = {
    URL: { count: 0, maxCount: 2 },
    PHONE_NUMBER: { count: 0, maxCount: 1 },
    QUICK_REPLY: { count: 0, maxCount: 10 },
    COPY_CODE: { count: 0, maxCount: 1 },
  };

  if (buttonsLen <= 2) {
    for (const button of buttons) {
      buttonsMetaData[button.type].count++;
    }
  }

  if (buttonsLen > 2) {
    let prevButton = buttons[0].type;
    buttonsMetaData[prevButton].count++;
    for (let idx = 1; idx < buttonsLen - 1; idx++) {
      const currentButton = buttons[idx].type;
      const nextButton = buttons[idx + 1].type;
      if (
        prevButton === "QUICK_REPLY" &&
        currentButton !== "QUICK_REPLY" &&
        nextButton === "QUICK_REPLY"
      ) {
        return { valid: false, msg: "Invalid Button Combination!" };
      }
      buttonsMetaData[currentButton].count++;
      prevButton = currentButton;
    }
    const lastButton = buttons[buttonsLen - 1].type;
    buttonsMetaData[lastButton].count++;
  }

  for (const key in buttonsMetaData) {
    if (buttonsMetaData[key].count > buttonsMetaData[key].maxCount) {
      return {
        valid: false,
        msg: `${key} button count is more than ${buttonsMetaData[key].maxCount}`,
      };
    }
  }

  for (const button of buttons) {
    const { type, text, url, phone_number, example } = button;

    if (["url", "URL"].includes(type)) {
      if (!validateUrl(url)) {
        return { valid: false, msg: "Invalid Button URL" };
      }
      const urlParams = extractParameters(url) || [];
      const exampleParams = example || [];
      if (exampleParams.length < urlParams.length) {
        return { valid: false, msg: "Missing URL Button Params Sample Value" };
      }
      for (const ex of exampleParams) {
        if (!ex?.length) {
          return { valid: false, msg: "URL sample value must not be empty!" };
        }
      }
    }

    if (["PHONE_NUMBER", "phone_number"].includes(type)) {
      const validNumberPattern = /^\d+$/;
      if (!validNumberPattern.test(phone_number)) {
        return { valid: false, msg: "Invalid Phone Number" };
      }
    }

    if (type === "COPY_CODE") {
      if (!example) {
        if (category === "AUTHENTICATION") {
          return { valid: false, msg: "Invalid Copy Code example value" };
        } else {
          return { valid: false, msg: "Invalid Coupon Code value" };
        }
      }
      if (!["MARKETING", "AUTHENTICATION"].includes(category)) {
        return {
          valid: false,
          msg: "Invalid Template Category for Copy Code Button. Only MARKETING and AUTHENTICATION category is allowed!",
        };
      }
    }

    if (
      !["COPY_CODE"].includes(type) &&
      (!text || !buttonTextPattern.test(text))
    ) {
      return { valid: false, msg: `Invalid ${type} Button Text` };
    }
  }

  return { valid: true, msg: "Button format for creating template is valid!" };
}

function parseButtonsToTemplateFormat(buttons) {
  const updatedButtons = [];
  for (const button of buttons) {
    if (["URL", "url"].includes(button.type)) {
      updatedButtons.push({
        type: button.type,
        text: button.text,
        url: button?.urlMetadata?.url || button.url,
        example: button?.urlMetadata?.parameters || button.example,
      });
    } else if (["phone_number", "PHONE_NUMBER"].includes(button.type)) {
      updatedButtons.push({
        type: button.type,
        text: button.text,
        phone_number: "",
        extension: button?.phoneMetadata?.extension,
        number: button?.phoneMetadata?.number,
      });
    } else {
      updatedButtons.push(button);
    }
  }
  return updatedButtons;
}

function validateLimitedTimeOffer(limitedTimeOffer = {}, buttons = [], templateCategory = "") {
  if (templateCategory && templateCategory !== "MARKETING") {
    return { valid: false, msg: "Limited Time Offer templates must use the MARKETING category!" };
  }
  if (!limitedTimeOffer.text) {
    return { valid: false, msg: "Limited Time Offer text is required!" };
  }
  if (limitedTimeOffer.text.length > 16) {
    return { valid: false, msg: "Limited Time Offer text must be at most 16 characters!" };
  }
  const hasUrlButton = buttons.some((b) => ["URL", "url"].includes(b.type));
  if (!hasUrlButton) {
    return { valid: false, msg: "Limited Time Offer templates require at least one URL button!" };
  }
  if (limitedTimeOffer.has_expiration) {
    const hasCopyCode = buttons.some((b) => b.type === "COPY_CODE");
    if (!hasCopyCode) {
      return {
        valid: false,
        msg: "Limited Time Offer templates with expiration require a Copy Code button!",
      };
    }
  }
  return { valid: true, msg: "Limited Time Offer is valid!" };
}

export default {
  compareFormatAndSample,
  extractParameters,
  validateFormat,
  validateUrl,
  validateAuthenticationTemplate,
  validateButtons,
  validateLimitedTimeOffer,
  parseButtonsToTemplateFormat,
};
